import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VAlert,
    {
      staticClass: "partition-validation",
      attrs: { type: "warning", outlined: "", dense: "" },
    },
    [
      _c("div", { staticClass: "font-weight-bold mb-1" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("create_attribute.partition_validation.panel_title")
            ) +
            " "
        ),
      ]),
      _c("div", { staticClass: "caption mb-2" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("create_attribute.partition_validation.panel_subtitle")
            ) +
            " "
        ),
      ]),
      _vm.summary
        ? _c("div", { staticClass: "partition-validation__summary mb-3" }, [
            _vm._v(" " + _vm._s(_vm.summary) + " "),
          ])
        : _vm._e(),
      _vm.normalizedErrors.length > 0
        ? _c(
            VExpansionPanels,
            {
              staticClass: "partition-validation__panels",
              attrs: { multiple: "", value: _vm.allPanels, flat: "" },
            },
            _vm._l(_vm.normalizedErrors, function (item, i) {
              return _c(
                VExpansionPanel,
                { key: i },
                [
                  _c(
                    VExpansionPanelHeader,
                    { staticClass: "partition-validation__header" },
                    [
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(_vm._s(item.table)),
                      ]),
                    ]
                  ),
                  _c(
                    VExpansionPanelContent,
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "partition-validation__meta caption mb-2",
                        },
                        [
                          item.partitionColumns
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.partition_validation.partition_column"
                                      )
                                    ) +
                                    ": "
                                ),
                                _c("strong", [
                                  _vm._v(_vm._s(item.partitionColumns)),
                                ]),
                              ])
                            : _vm._e(),
                          item.line
                            ? _c("span", [
                                _vm._v(
                                  " · " +
                                    _vm._s(
                                      _vm.$t(
                                        "create_attribute.partition_validation.line",
                                        { n: item.line }
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      item.snippet
                        ? [
                            _c("div", { staticClass: "field-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.partition_validation.detected_code"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("pre", { staticClass: "code-block mb-3" }, [
                              _vm._v(_vm._s(item.snippet)),
                            ]),
                          ]
                        : _vm._e(),
                      item.why
                        ? [
                            _c("div", { staticClass: "field-label" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "create_attribute.partition_validation.why_fails"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("p", { staticClass: "mb-3" }, [
                              _vm._v(_vm._s(item.why)),
                            ]),
                          ]
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-center justify-space-between",
                        },
                        [
                          _c("span", { staticClass: "field-label" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.partition_validation.how_to_fix"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          item.suggestion
                            ? _c(
                                VBtn,
                                {
                                  attrs: {
                                    "x-small": "",
                                    text: "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.copy(item.suggestion)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    VIcon,
                                    { attrs: { "x-small": "", left: "" } },
                                    [_vm._v("mdi-content-copy")]
                                  ),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "create_attribute.partition_validation.copy"
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      item.suggestion
                        ? _c("pre", { staticClass: "code-block mb-0" }, [
                            _vm._v(_vm._s(item.suggestion)),
                          ])
                        : _c("p", { staticClass: "caption mb-0 font-italic" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "create_attribute.partition_validation.no_suggestion"
                                  )
                                ) +
                                " "
                            ),
                          ]),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }